"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GALLERIES_RECEIVED = exports.GALLERY_OPEN = void 0;
const EntityStore_1 = require("./EntityStore");
const Entities_1 = require("../../backend/models/Entities");
class GalleryStore extends EntityStore_1.default {
    constructor(dispatcher) {
        super(dispatcher, Entities_1.Gallery);
        this.dispatcher = dispatcher;
    }
}
GalleryStore.storeName = 'GalleryStore';
GalleryStore.handlers = {
    GALLERIES_RECEIVED: 'handleEntities',
    GALLERY_OPEN: 'handleEntity',
};
exports.GALLERY_OPEN = 'GALLERY_OPEN';
exports.GALLERIES_RECEIVED = 'GALLERIES_RECEIVED';
exports.default = GalleryStore;
